module.exports = __webpack_public_path__ + "img/proyecto_9_mv.80e77ee6.png";